//
// VerticalPosition.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var VerticalPosition = {
    TOP:0,
    MIDDLE:1,
    BOTTOM:2
};
export default VerticalPosition;
